/* GeneratedContentHash: c6a42f2b2327fcd85b4ea2b2e86b6685f427c7c37ed80e4c0876169b1b29677d */
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/

export const PLACEMENT_ID = 'jira-your-work';
